/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 通知状态
 */
let EnumNoticeType = {
	Noticed                 : new EnumItem('已通知', 0),
	UnNotice                : new EnumItem('未通知', 1),
	...enumMixn
}
export default EnumNoticeType
